import React from "react";
import { Dna } from "react-loader-spinner";

const Loading = () => {
  return (
    <div
      className="flex justify-center items-center w-full min-h-screen
    "
    >
      <Dna
        visible={true}
        height="80"
        width="80"
        ariaLabel="dna-loading"
        wrapperStyle={{}}
        wrapperClass="dna-wrapper"
      />
    </div>
  );
};

export default Loading;
